(() => {
  const root = window.Shopify?.routes?.root || '/';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = window.Shopify?.designMode === true;
  if (designMode) document.documentElement.classList.add('shopify-design-mode');
  const revealObserver = !reduceMotion && !designMode && 'IntersectionObserver' in window
    ? new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 })
    : null;

  /* Shopify rendert secties opnieuw in de Theme Editor. Initialiseer daarom
     ook nieuw ingevoegde inhoud, in plaats van alleen bij de eerste paginalaad. */
  const initReveal = (scope = document) => {
    const revealItems = [];
    if (scope instanceof Element && scope.matches('.reveal')) revealItems.push(scope);
    revealItems.push(...scope.querySelectorAll('.reveal:not([data-reveal-ready])'));

    revealItems.forEach((item) => {
      item.dataset.revealReady = 'true';
      if (!revealObserver) item.classList.add('is-visible');
      else revealObserver.observe(item);
    });
  };

  const closeMenu = () => {
    const menuButton = document.querySelector('[data-mobile-menu-button]');
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    mobileMenu?.classList.remove('is-open');
    menuButton?.setAttribute('aria-expanded', 'false');
    menuButton?.setAttribute('aria-label', 'Menu openen');
    document.body.classList.remove('menu-is-open');
  };

  document.addEventListener('click', (event) => {
    const menuButton = event.target.closest('[data-mobile-menu-button]');
    if (menuButton) {
      const mobileMenu = document.querySelector('[data-mobile-menu]');
      if (!mobileMenu) return;
      const open = !mobileMenu.classList.contains('is-open');
      mobileMenu.classList.toggle('is-open', open);
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? 'Menu sluiten' : 'Menu openen');
      document.body.classList.toggle('menu-is-open', open);
      return;
    }

    if (event.target.closest('[data-mobile-menu] a')) {
      closeMenu();
      return;
    }

    const minus = event.target.closest('[data-quantity-minus]');
    const plus = event.target.closest('[data-quantity-plus]');
    const button = minus || plus;
    if (button) {
      const input = button.parentElement.querySelector('input[name="quantity"]');
      if (!input) return;
      const current = Number(input.value) || 1;
      input.value = String(Math.max(1, Math.min(10, current + (plus ? 1 : -1))));
      return;
    }

    const variantButton = event.target.closest('[data-variant-button]');
    if (variantButton) {
      if (variantButton.getAttribute('aria-disabled') === 'true') return;
      updateVariant(variantButton.closest('.airme-product-form'), variantButton);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenu();
  });

  const updateVariant = (form, button) => {
    if (!form || !button) return;
    const context = form.closest('[data-product-context]') || form.parentElement;
    const input = form.querySelector('[data-variant-input]');
    const available = button.dataset.available === 'true';
    if (input) input.value = button.dataset.variantId || '';

    form.querySelectorAll('[data-variant-button]').forEach((item) => {
      const selected = item === button;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-checked', String(selected));
      const label = item.querySelector('small');
      if (label) label.textContent = selected ? 'Geselecteerd' : (item.dataset.available === 'true' ? 'Kies' : 'Uitverkocht');
    });

    const priceBox = context?.querySelector('[data-product-price]');
    const currentPrice = priceBox?.querySelector('strong');
    let oldPrice = priceBox?.querySelector('del');
    if (currentPrice && button.dataset.price) currentPrice.textContent = button.dataset.price;
    if (priceBox && button.dataset.comparePrice && !oldPrice) {
      oldPrice = document.createElement('del');
      priceBox.prepend(oldPrice);
    }
    if (oldPrice) {
      oldPrice.textContent = button.dataset.comparePrice || '';
      oldPrice.hidden = !button.dataset.comparePrice;
    }

    const image = context?.querySelector('[data-variant-image]');
    if (image && button.dataset.image && image.src !== button.dataset.image) {
      image.classList.add('is-switching');
      const nextImage = new Image();
      nextImage.onload = () => {
        image.src = button.dataset.image;
        image.alt = button.dataset.alt || 'AirMe Neck Cooler';
        image.classList.remove('is-switching');
      };
      nextImage.onerror = () => image.classList.remove('is-switching');
      nextImage.src = button.dataset.image;
    }

    const stockLine = context?.querySelector('[data-stock-line]');
    const stockText = context?.querySelector('[data-stock-text]');
    stockLine?.classList.toggle('is-unavailable', !available);
    if (stockText) stockText.textContent = available ? 'Op voorraad' : 'Momenteel niet op voorraad';
    form.querySelectorAll('button[type="submit"]').forEach((submit) => { submit.disabled = !available; });
    form.dataset.variantAvailable = String(available);

    const message = form.querySelector('[data-product-form-message]');
    if (message) {
      message.textContent = '';
      message.classList.remove('is-error');
    }
  };

  const initProductForms = (scope = document) => {
    const forms = [];
    if (scope instanceof Element && scope.matches('.airme-product-form')) forms.push(scope);
    forms.push(...scope.querySelectorAll('.airme-product-form'));
    forms.forEach((form) => {
      const selected = form.querySelector('[data-variant-button].is-selected');
      if (!selected) return;
      const available = selected.dataset.available === 'true';
      form.dataset.variantAvailable = String(available);
      form.querySelectorAll('button[type="submit"]').forEach((button) => { button.disabled = !available; });
    });
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest('.airme-product-form select[name="id"]');
    if (!select) return;
    const form = select.closest('.airme-product-form');
    const option = select.options[select.selectedIndex];
    const linkedButton = form.querySelector(`[data-variant-id="${CSS.escape(option.value)}"]`);
    if (linkedButton) updateVariant(form, linkedButton);
  });

  initReveal();
  initProductForms();

  document.addEventListener('shopify:section:load', (event) => {
    initReveal(event.target);
    initProductForms(event.target);
  });

  document.addEventListener('shopify:section:select', (event) => {
    event.target.querySelectorAll('.reveal').forEach((item) => item.classList.add('is-visible'));
  });

  document.addEventListener('shopify:block:select', (event) => {
    const revealItem = event.target.closest('.reveal');
    revealItem?.classList.add('is-visible');
  });

  const showToast = (message) => {
    const toast = document.querySelector('[data-airme-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    window.setTimeout(() => { toast.hidden = true; }, 2800);
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.airme-product-form');
    if (!form) return;
    event.preventDefault();
    const submitter = event.submitter;
    const message = form.querySelector('[data-product-form-message]');
    const buttons = form.querySelectorAll('button[type="submit"]');
    buttons.forEach((button) => { button.disabled = true; });
    if (message) {
      message.textContent = 'AirMe wordt toegevoegd…';
      message.classList.remove('is-error');
    }
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('Toevoegen is niet gelukt. Controleer de gekozen uitvoering.');
      if (submitter?.hasAttribute('data-buy-now')) {
        window.location.href = `${root}checkout`;
        return;
      }
      const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
      if (message) message.textContent = 'Toegevoegd aan je winkelmand.';
      showToast('AirMe is toegevoegd aan je winkelmand.');
    } catch (error) {
      if (message) {
        message.textContent = error.message || 'Er ging iets mis. Probeer het opnieuw.';
        message.classList.add('is-error');
      }
    } finally {
      const variantUnavailable = form.dataset.variantAvailable === 'false';
      buttons.forEach((button) => { button.disabled = variantUnavailable; });
    }
  });
})();
